import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { TimerProvider } from "./contexts/TimerContext";
import { LocationProvider } from "./contexts/LocationContext";
import { BookingProvider } from "./contexts/BookingContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import BookingPage from "./pages/BookingPage";
import SeatSelectionPage from "./pages/SeatSelectionPage";
import SnacksPage from "./pages/SnacksPage";
import PaymentPage from "./pages/PaymentPage";
import CinemaPage from "./pages/CinemaPage";
import UserProfile from "./pages/UserProfile";
import CmsPage from "./pages/CmsPage";
import AdvertiseWithUs from "./pages/AdvertiseWithUs";
import AboutUs from "./pages/AboutUs";
import ContactUsPage from "./pages/ContactUsPage";
import BookingDetailsPage from "./pages/BookingDetailsPage";
import Cinemas from "./pages/CinemaListingPage";
import SpecialScreeningBulkBooking from "./pages/SpecialScreeningBulkBooking";

import "./App.css";
import ShowTimeCinemas from "./pages/ShowTimePage";
import Offers from "./pages/Offers";
import MamangamHallBooking from "./components/MamangamHallBooking";
import HallBookingDetail from "./components/HallBookingdetail";

function App() {
  // Google OAuth Client ID from REACT_APP_GOOGLE_CLIENT_ID (matches
  // backend GOOGLE_CLIENT_ID for audience verification).
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <SettingsProvider>
        <LocationProvider>
          <TimerProvider>
            <BookingProvider>
              <Router>
                <div className="App">
                  <ScrollToTop />
                  <Header />
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/cinemas" element={<Cinemas />} />
                    <Route path="/show-times" element={<ShowTimeCinemas />} />
                    <Route path="/cinema/:cinemaId" element={<CinemaPage />} />
                    <Route path="/booking/:movieId" element={<BookingPage />} />
                    <Route
                      path="/seat-selection"
                      element={<SeatSelectionPage />}
                    />
                    <Route path="/snacks" element={<SnacksPage />} />
                    <Route path="/payment" element={<PaymentPage />} />
                    <Route path="/profile" element={<UserProfile />} />
                    <Route
                      path="/booking/view/:token"
                      element={<BookingDetailsPage />}
                    />
                    <Route path="/b/:code" element={<BookingDetailsPage />} />
                    <Route
                      path="/advertise-with-us"
                      element={<AdvertiseWithUs />}
                    />
                    <Route
                      path="/page/about-us"
                      element={<Navigate to="/about-us" replace />}
                    />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/page/:slug" element={<CmsPage />} />
                    <Route path="/pages/:slug" element={<CmsPage />} />
                    <Route path="/contact-us" element={<ContactUsPage />} />
                    <Route path="/offers" element={<Offers />} />
                    <Route
                      path="/mamangam-hall-booking"
                      element={<MamangamHallBooking />}
                    />
                    <Route
                      path="/mamangam-hall-booking-details"
                      element={<HallBookingDetail />}
                    />
                    <Route
                      path="/special-screening-bulk-booking"
                      element={<SpecialScreeningBulkBooking />}
                    />
                    {/* Backwards compatibility: old CMS slug now redirects to the dedicated page */}
                    <Route
                      path="/page/specialscreeningbulkbooking"
                      element={
                        <Navigate to="/special-screening-bulk-booking" replace />
                      }
                    />
                  </Routes>
                  <Footer />
                  <CookieConsent />
                </div>
              </Router>
            </BookingProvider>
          </TimerProvider>
        </LocationProvider>
      </SettingsProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
